module.exports = __webpack_public_path__ + "img/icon-1.2f949949.png";